import React, {useState} from 'react'
import PathCopyShortcut from "./pathCopyShortcut";
import FileUpload from "./fileUpload";

const flexContainer = {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    flex: 1
}
const secondChild = {
    display: 'flex',
    flexWrap: 'nowrap',
    marginLeft: '16px'
}

const UploaderAndPath = () => {
    const [uploadStatus, setUploadStatus] = useState(false)
    const [path, setPath] = useState('')

    const toggleUploadStatus = (status) => uploadStatus !== status ?  setUploadStatus(status) : null
    const updatePath = (url) => setPath(url)

    return(
        <React.Fragment>
            <div style={flexContainer}>
                <div>
                    <FileUpload statusToggle={toggleUploadStatus} pathUpdater={updatePath} />
                </div>
                <div style={secondChild}>
                    {uploadStatus ? <PathCopyShortcut path={path} /> : null}
                </div>
            </div>
        </React.Fragment>
    )
}
export default UploaderAndPath